export const SHAREHOLDERS_SECTION_CONTENT = {
    heading: 'Dla akcjonariuszy',
    seoDescription:
        'Informacje dla akcjonariuszy PayPo: organy spółki, statut, walne zgromadzenia, ogłoszenia, akcje i kapitał oraz kontakt.',
    tabsLabel: 'Zakładki',
    downloadPdf: 'Pobierz plik PDF',
    opensInNewTab: 'otwiera się w nowej karcie',
    statuteUpdatedAt: 'Ostatnia aktualizacja:',
    date: 'Data:',
    paginationLabel: 'Stronicowanie',
    unavailable: 'Informacje są chwilowo niedostępne',
    emptyTab: 'Brak opublikowanych informacji',
    meeting: {
        upcomingTab: 'Najbliższe',
        archiveTab: 'Archiwum',
        noticePublishedAt: 'Opublikowane:',
        timePrefix: 'godzina',
        when: 'Kiedy?',
        where: 'Gdzie?',
        emptyState: 'Brak zaplanowanych walnych zgromadzeń',
        archiveEmptyState: 'Brak walnych zgromadzeń w archiwum',
    },
    shares: {
        shareCapital: 'Kapitał zakładowy',
        sharesCount: 'Liczba akcji',
        nominalValue: 'Wartość nominalna akcji',
        votesCount: 'Liczba głosów',
        seriesHeading: 'Struktura i serie akcji',
        seriesColumns: {
            name: 'Seria akcji',
            sharesCount: 'Liczba akcji',
            nominalValue: 'Wartość nominalna akcji',
            totalValue: 'Łączna wartość nominalna',
            numbering: 'Numeracja akcji',
        },
        capitalHistoryHeading: 'Historia zmian kapitału zakładowego',
        capitalChangeDate: 'Zmiana z dnia',
    },
};
